import data from "../data";
import columns from "./tableColumns";
import columnsG from "./tableColumnsGenerated";
import { Spin, Table } from "antd";
import { usePaginationPrzelewy } from "../../../context/PaginationContextPrzelewy";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchInput from "./search";
import GenerateXML from "./GenerateXML";
import { useContext } from "react";
import ShowGenerated from "./ShowGenerated";
import formatPrice from "../../../components/formatPrice";
const WplywyTable = () => {
	const { pagination, setPagination } = usePaginationPrzelewy();
	const navigate = useNavigate();
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [selectedRowsByKey, setSelectedRowsByKey] = useState({});

	const normalizeKey = (key) => String(key);

	const handleRowClick = (record) => {
		if (!record.msr_generated_files_id) {
			setSelectedRowKeys((prevSelectedKeys) => {
				const recordKey = normalizeKey(record.key);
				const prevKeysNormalized = prevSelectedKeys.map(normalizeKey);
				if (prevKeysNormalized.includes(recordKey)) {
					setSelectedRowsByKey((prev) => {
						const next = { ...prev };
						delete next[recordKey];
						return next;
					});
					return prevSelectedKeys.filter(
						(key) => normalizeKey(key) !== recordKey
					);
				} else {
					setSelectedRowsByKey((prev) => ({
						...prev,
						[recordKey]: record,
					}));
					return [...prevSelectedKeys, record.key];
				}
			});
		}
	};

	// Handle row selection
	const onSelectChange = (selectedKeys, selectedRows) => {
		setSelectedRowKeys(selectedKeys);
		setSelectedRowsByKey((prev) => {
			const next = {};
			// Keep any previously known rows that are still selected
			selectedKeys.forEach((key) => {
				const normalized = normalizeKey(key);
				if (prev[normalized]) next[normalized] = prev[normalized];
			});
			// Add/refresh rows from current selection callback
			(selectedRows || []).forEach((row) => {
				next[normalizeKey(row.key)] = row;
			});
			return next;
		});
	};

	// Define rowSelection property for Table
	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
		getCheckboxProps: (record) => ({
			disabled: !!record.msr_generated_files_id, // Disable checkbox if msr_generated_files_id exists
		}),
	};

	const handleTableChange = (paginationInfo) => {
		const { current, pageSize } = paginationInfo;
		setPagination((prev) => ({
			...prev,
			current, // Update the current page
			pagesize: pageSize, // Update the page size
		}));
	};

	const rows = data();

	const selectedCount = selectedRowKeys.length;
	const selectedTotal = selectedRowKeys.reduce((sum, key) => {
		const row = selectedRowsByKey[normalizeKey(key)];
		const amount = parseFloat(row?.msr_transfers_amount || 0);
		return sum + (Number.isFinite(amount) ? amount : 0);
	}, 0);

	return (
		<>
			<div
				className="table-header"
				style={{
					display: "flex",
					alignItems: "center",
					gap: "10px",
					marginBottom: "16px",
					padding: "20px",
					paddingBottom: "0",
				}}
			>
				<SearchInput></SearchInput>
				{selectedCount > 0 && (
					<div
						style={{
							alignSelf: "center",
							whiteSpace: "nowrap",
							padding: "0 8px",
						}}
					>
						Zaznaczone: <b>{selectedCount}</b> | Suma:{" "}
						<b>{formatPrice(selectedTotal)} zł</b>
					</div>
				)}
				<GenerateXML
					ids={selectedRowKeys}
					setSelectedRowKeys={setSelectedRowKeys}
				></GenerateXML>
			</div>
			<div
				className="table-body"
				style={{ padding: "20px", paddingTop: "0" }}
			>
				<Spin spinning={pagination.loading}>
					<Table
						rowSelection={rowSelection} // Add rowSelection property
						columns={columnsG}
						onChange={handleTableChange} // Handle pagination changes
						dataSource={rows.data}
						loading={pagination.loading}
						expandIcon={false}
						pagination={{
							current: pagination.current,
							pageSize: pagination.pagesize,
							total: rows.total, // Replace with total number of records from your server
							showSizeChanger: true, // Allows changing the page size
							pageSizeOptions: ["1", "10", "20", "50", "100"],
						}}
						onRow={(record) => ({
							onClick: () => handleRowClick(record),
						})}
					/>
				</Spin>
			</div>
		</>
	);
};

export default WplywyTable;
